<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :module-enabler="moduleEnabler"
    :inputs="inputs"
    :has-buttons="false"
  >
    <template #table.input>
      <external-systems-table
        :inputs="dbGisBoxInputs"
        :inputs-editing="dbGisBoxEditingInputs"
        :external-systems="externalSystems"
        :available-systems="availableSystems"
        :init-gets="initGets"
        :delete-connection="deleteConnection"
        :edit-connection="editConnection"
        :add-connection="addConnection"
        :refresh-view="refreshView"
        has-id-header
      />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import ExternalSystemsTable from '@/components/ExternalSystemsTable';
import { call, get } from 'vuex-pathify';
export default {
  name: 'DbGisBoxSettings',
  components: { ExternalSystemsTable, AdminWrapper },
  computed: {
    additionalModuleName: get('admin/additionalModules@EXTERNAL_DB.verbose_name'),
    externalSystems: get('externalSystems/dbGisBoxSystems'),
    availableSystems: get('externalSystems/availableDbGisBoxSystems'),
    isModuleEnabled: get('admin/settingsValues@external_db_module_enabled'),
    dbGisBoxInputs() {
      return [
        'system',
        'host',
        'port',
        'username',
        'password',
        'dbname',
        'external_schema_name',
        'external_table_name',
        'external_source_field',
        'migration_type',
        'as_datasource',
        'datasource_name',
      ];
    },
    dbGisBoxEditingInputs() {
      return ['host', 'port', 'username', 'password', 'dbname'];
    },
    inputs() {
      return [
        {
          name: 'table',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'external_db_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  methods: {
    getExternalSystems: call('externalSystems/getDbGisBoxSystems'),
    getAvailableSystems: call('externalSystems/getAvailableDbGisBoxSystems'),
    deleteConnection: call('externalSystems/deleteDbGisBoxConnection'),
    addConnection: call('externalSystems/addDbGisBoxConnection'),
    editConnection: call('externalSystems/editDbGisBoxConnection'),
    refreshView: call('externalSystems/refreshDbGisBoxView'),
    async initGets() {
      await this.getExternalSystems();
      await this.getAvailableSystems();
    },
  },
};
</script>
